import React from "react";

const COLORS = {
  PENDING: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  CONNECTING: { bg: "bg-sky-500/15", text: "text-sky-300", border: "border-sky-500/30", dot: "bg-sky-400" },
  UPLOADING: { bg: "bg-blue-500/15", text: "text-blue-300", border: "border-blue-500/30", dot: "bg-blue-400" },
  VALIDATING: { bg: "bg-cyan-500/15", text: "text-cyan-300", border: "border-cyan-500/30", dot: "bg-cyan-400" },
  EXECUTING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30", dot: "bg-amber-400" },
  HEALTHCHECK: { bg: "bg-violet-500/15", text: "text-violet-300", border: "border-violet-500/30", dot: "bg-violet-400" },
  SUCCESS: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  DEPLOYED: { bg: "bg-emerald-600/20", text: "text-emerald-200", border: "border-emerald-500/50", dot: "bg-emerald-500" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30", dot: "bg-rose-400" },
  CANCELLED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
  ROLLING_BACK: { bg: "bg-orange-500/15", text: "text-orange-300", border: "border-orange-500/30", dot: "bg-orange-400" },
  ROLLBACK: { bg: "bg-teal-500/15", text: "text-teal-300", border: "border-teal-500/30", dot: "bg-teal-400" },
  ROLLBACK_FAILED: { bg: "bg-rose-600/20", text: "text-rose-200", border: "border-rose-500/50", dot: "bg-rose-500" },
};

const RUNNING_STATUSES = new Set(["CONNECTING", "UPLOADING", "VALIDATING", "EXECUTING", "HEALTHCHECK", "ROLLING_BACK"]);

export function ExecutionStatusBadge({ status, size = "md" }) {
  const c = COLORS[status] || COLORS.PENDING;
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  const pulse = RUNNING_STATUSES.has(status) ? "animate-pulse" : "";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${cls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`execution-status-${status.toLowerCase()}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot} ${pulse}`} /> {status}
    </span>
  );
}

const ADAPTER_COLORS = {
  MOCK: "bg-neutral-500/15 text-neutral-300 border-neutral-500/30",
  LOCAL: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  SSH: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  DOCKER: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
};

export function AdapterBadge({ adapter }) {
  const cls = ADAPTER_COLORS[adapter] || ADAPTER_COLORS.MOCK;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-mono font-bold text-[10px] px-2 py-0.5 ${cls}`}
      data-testid={`execution-adapter-${(adapter || "").toLowerCase()}`}>
      {adapter}
    </span>
  );
}

export function HealthBadge({ result }) {
  if (!result) return <span className="text-[10px] text-white/40">—</span>;
  const ok = result.healthy;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-black text-[10px] px-2 py-0.5 ${
      ok ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
         : "bg-rose-500/15 text-rose-300 border-rose-500/30"
    }`} data-testid={`execution-health-${ok ? "ok" : "fail"}`}>
      {ok ? "HEALTHY" : "UNHEALTHY"} · {result.total || 0}
    </span>
  );
}
